.alert {
  display: flex;
  gap: var(--space-3);
  align-items: flex-start;
  padding: var(--space-3);
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-info-subtle);
  color: var(--color-text);
}

.alert[data-tone="success"] {
  background: var(--color-success-subtle);
}

.alert[data-tone="warning"] {
  background: var(--color-warning-subtle);
}

.alert[data-tone="danger"] {
  background: var(--color-danger-subtle);
}

.icon {
  display: inline-flex;
  padding-block-start: calc(var(--space-1) / 2);
  color: var(--color-info);
}

.alert[data-tone="success"] .icon {
  color: var(--color-success);
}

.alert[data-tone="warning"] .icon {
  color: var(--color-warning);
}

.alert[data-tone="danger"] .icon {
  color: var(--color-danger);
}

.text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-1);
  min-inline-size: 0;
}

.title {
  font-size: var(--text-md);
  font-weight: var(--weight-medium);
  line-height: var(--leading-tight);
}

.body {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
}

.action {
  display: flex;
  flex: none;
  gap: var(--space-2);
  align-items: center;
}
